module.exports = __webpack_public_path__ + "0af2ec745e0893f61ebb82a67bd0c5d0.pdf";